let isLoading = false;
let activeObserver = null;

const loadItems = (button) => {
  if (isLoading) return;
  isLoading = true;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + (currentPage + 1));
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  // Disconnect the existing observer before loading so it cannot
  // fire again while the request is in flight
  if (activeObserver) {
    activeObserver.disconnect();
    activeObserver = null;
  }

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML) {
      const newItems = $(responseHTML).find('.load-more-grid li.collection-product-card');
      newItems.each(function() {
        const wrapper = $(this).find('[data-product]');
        const handle = wrapper.length ? wrapper.attr('data-product') : null;
        // Skip if this product handle is already in the grid
        if (handle) {
          const existing = $('.load-more-grid [data-product="' + handle + '"]');
          if (existing.length) return;
        }
        $('.load-more-grid').append($(this));
      });
      colorSwatches();
    },
    complete: function() {
      isLoading = false;
      button.removeAttribute("disabled");
      button.classList.remove('loading');

      if (currentPage >= totalPages) {
        button.remove();
        return;
      }

      // Update scroll data for the next page
      const scrollData = document.querySelector('.infinite-scroll__data');
      if (scrollData) {
        scrollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
        scrollData.querySelector('input[data-next-url]').value = nextUrlScroll;
        scrollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
        scrollData.querySelector('input[data-current-page]').value = currentPage;
      }

      // Re-attach a single fresh observer now that the page has loaded
      checkVisibility();
    }
  });
}

const checkVisibility = () => {
  // Disconnect any previous observer before creating a new one
  if (activeObserver) {
    activeObserver.disconnect();
    activeObserver = null;
  }

  const spinner = document.querySelector('.js-infinite-scroll');
  if (!spinner) return;

  activeObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadItems(spinner);
      }
    });
  }, { rootMargin: '0px 0px 2000px 0px' }); // preload next page 2000px before spinner is visible

  activeObserver.observe(spinner);
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();